var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useMemo } from "react";
import { Box, Divider, Grid } from "@mui/material";
import { useFormContext } from "react-hook-form";
import FormField from "../FormField";
import SurveyPageHeader from "../../../../components/SurveyPageHeader";
import FormLogicProvider, { useElementConditions, useFormLogic, } from "../../context/FormLogicContext";
import { flattenPageElements, getCommentFieldName, } from "../../../../utils/forms-functions";
import { getElementValueKey } from "../../../../utils/helpers";
import { chunkRow, getItemGridSize, groupElementsIntoRows, useMaxItemsPerRow, } from "../../utils/layout-utils";
import { useClearInvisibleValue } from "../../hooks/useClearInvisibleValue";
var PanelFieldContent = function (_a) {
    var _b;
    var element = _a.element, errors = _a.errors, panelEnabledFallback = _a.panelEnabledFallback, isDisplayMode = _a.isDisplayMode, formValues = _a.formValues, elementsTypeInfoByName = _a.elementsTypeInfoByName, globalConstraints = _a.globalConstraints, textUpdateMode = _a.textUpdateMode, clearInvisibleValues = _a.clearInvisibleValues, storeOthersAsComment = _a.storeOthersAsComment;
    var maxItemsPerRow = useMaxItemsPerRow();
    var panelElements = (_b = element.elements) !== null && _b !== void 0 ? _b : [];
    var logicalRows = groupElementsIntoRows(panelElements);
    return (_jsx(FormLogicProvider, __assign({ formValues: formValues, elementsTypeInfoByName: elementsTypeInfoByName, globalConstraints: globalConstraints, pageEnabledFallback: panelEnabledFallback, isDisplayMode: isDisplayMode, textUpdateMode: textUpdateMode, clearInvisibleValues: clearInvisibleValues, storeOthersAsComment: storeOthersAsComment }, { children: _jsx(Grid, __assign({ container: true, spacing: 2 }, { children: logicalRows.flatMap(function (logicalRow) {
                return chunkRow(logicalRow, maxItemsPerRow).flatMap(function (visualRow) {
                    return visualRow.map(function (childElement, index) { return (_jsx(Grid, __assign({ item: true, xs: getItemGridSize(visualRow.length, index === visualRow.length - 1), "data-element-name": childElement.name }, { children: _jsx(FormField, { element: childElement, errors: errors }) }), childElement.name)); });
                });
            }) })) })));
};
var PanelField = function (_a) {
    var element = _a.element, errors = _a.errors;
    var _b = useFormLogic(), formValues = _b.formValues, elementsTypeInfoByName = _b.elementsTypeInfoByName, globalConstraints = _b.globalConstraints, pageEnabledFallback = _b.pageEnabledFallback, isDisplayMode = _b.isDisplayMode, textUpdateMode = _b.textUpdateMode, clearInvisibleValues = _b.clearInvisibleValues, storeOthersAsComment = _b.storeOthersAsComment;
    var unregister = useFormContext().unregister;
    var _c = useElementConditions(element), isVisible = _c.isVisible, isEnabled = _c.isEnabled;
    var nestedFieldNames = useMemo(function () {
        var _a;
        return flattenPageElements((_a = element.elements) !== null && _a !== void 0 ? _a : []).flatMap(function (el) {
            var nestedValueKey = getElementValueKey(el);
            return el.showCommentArea
                ? [nestedValueKey, getCommentFieldName(nestedValueKey)]
                : [nestedValueKey];
        });
    }, [element.elements]);
    useClearInvisibleValue({
        isVisible: isVisible,
        valueKeys: nestedFieldNames,
        unregister: unregister,
        reason: "container",
    });
    var panelEnabledFallback = isEnabled && pageEnabledFallback;
    return (_jsx(_Fragment, { children: isVisible ? (_jsxs(Box, __assign({ sx: {
                backgroundColor: "white",
                border: "1px solid",
                borderColor: "divider",
                borderRadius: 0.5,
                overflow: "hidden",
            } }, { children: [(element.title || element.description) && (_jsx(Box, __assign({ sx: { px: 2, pt: 2 } }, { children: _jsx(SurveyPageHeader, { title: element.title, description: element.description }) }))), _jsx(Divider, {}), _jsx(Box, __assign({ sx: { p: 2 } }, { children: _jsx(PanelFieldContent, { element: element, errors: errors, panelEnabledFallback: panelEnabledFallback, isDisplayMode: isDisplayMode, formValues: formValues, elementsTypeInfoByName: elementsTypeInfoByName, globalConstraints: globalConstraints, textUpdateMode: textUpdateMode, clearInvisibleValues: clearInvisibleValues, storeOthersAsComment: storeOthersAsComment }) }))] }))) : null }));
};
export default PanelField;
